import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import { postInvites, setOnboardingStep } from 'state/actions'

import AlertBanner from 'components/alerts/alert-banner'

import {
	getAccountUsers,
	getCurrentAccount,
	getCurrentUser,
} from 'state/selectors'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'
import { parsedEmailAddresses } from 'utils/utils'

class ModalInvite extends Component {
	state = {
		recipientEmails: '',
	}

	freeUsersLeft = -1

	componentWillMount() {
		const { accountData, allInvitations } = this.props

		if (accountData.lifetime_amount) {
			let allUsersOrNonGuestInvitations = accountData.users.filter(userId => accountData.guestIds.indexOf(userId) === -1).length

			accountData.invitations.forEach(invitationId => {
				const invitationObject = allInvitations[invitationId]

				if (invitationObject && !invitationObject.completed && !invitationObject.is_guest) {
					allUsersOrNonGuestInvitations++
				}
			})

			this.freeUsersLeft = accountData.lifetime_amount - allUsersOrNonGuestInvitations
		}
	}

	postInvites = _ => {
		const {
			isLoading,
			accountUsers,
			setLoading,
			data,
			postInvites,
			handleSuccess,
			closeCallback,
			handleError,
			setOnboardingStep,
			userData
		} = this.props

		if (isLoading) {
			return
		}
		const emails = this.state.recipientEmails

		const parseResponse = parsedEmailAddresses(emails)

		const isGuest = data && data.type && data.type == 'guest'

		if (parseResponse.allValid) {
			let uniqueEmails = []

			parseResponse.validAddresses.forEach(email => {
				if (uniqueEmails.indexOf(email) == -1) {
					uniqueEmails.push(email)
				}
			})

			let firstExistingEmail = null

			accountUsers.forEach(user => {
				if (!firstExistingEmail) {
					firstExistingEmail = parseResponse.validAddresses.find(address => {
						return address == user.email
					})
				}
			})

			if (firstExistingEmail) {
				handleError("'" + firstExistingEmail + "' is already part of your team.")
				return
			}

			setLoading(true)

			postInvites(uniqueEmails, isGuest, _ => {
				setLoading(false)
				handleSuccess("Success! Users have been invited.")
				this.refs.recipientEmails.value = ''

				setOnboardingStep('INVITED_USER', userData)

				setTimeout(_ => {
					closeCallback()
				}, 1000)
			})
		} else {
			if (parseResponse.invalidAddresses.length) {
				handleError("'" + parseResponse.invalidAddresses[0] + "' isn't a valid email address.")
			} else {
				handleError("You'll need to enter some addresses first!")
			}
		}
	}

	updateRecipientEmails = _ => {
		this.setState({
			recipientEmails: this.refs.recipientEmails.value
		})
	}

	render() {
		const {
			accountData
		} = this.props

		setTimeout(_ => {
			if (this.refs.recipientEmails) {
				this.refs.recipientEmails.focus()
			}
		}, 1)

		return (
			<div>
				<div className={'borders'}>
					{this.freeUsersLeft > -1 ?
						<AlertBanner
							title={(() => {
								if (this.freeUsersLeft > 0) {
									return `You have ${this.freeUsersLeft} free user${this.freeUsersLeft === 1 ? '' : 's'} left!`
								}

								return `You have no free users left.`
							})()}
							body={(() => {
								if (this.freeUsersLeft > 0) {
									return `Enter their email addresses below, and we'll send them an invite.`
								}

								return `Please <a target="_blank" href="https://hassl.co/contact">contact us</a> and we'll set up a billing account for you.`
							})()}
						/>
						: null}
					<textarea
						onChange={this.updateRecipientEmails}
						ref="recipientEmails"
						placeholder="Enter each email address on a new line"
					/>
					<ValidateResponse
						dismissCallback={this.props.handleDismiss}
						response={this.props.validateResponse}
					/>
				</div>
				<Button
					size={'big'}
					level={'high'}
					callback={this.postInvites}
					label={'Add member'}
					disabled={this.freeUsersLeft === 0}
					icon={'check'}
				/>
				<Button
					size={'big'}
					level={'low'}
					callback={this.props.closeCallback}
					label={'Cancel'}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		accountData: getCurrentAccount(state),
		userData: getCurrentUser(state),
		accountUsers: getAccountUsers(state),
		forceHideActivation: state.auth.forceHideActivation,
		allInvitations: state.account.entities.invitations,
	}
}

const ModalInviteWithValidateResponse = withValidateResponse(ModalInvite);

export default connect(mapStateToProps, {
	postInvites,
	setOnboardingStep
})(ModalInviteWithValidateResponse)



// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-invite.jsx